import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonCol, IonGrid, IonRow } from "@ionic/vue";

import ButtonBase from "@/components/button/ButtonBase.vue";

import { BUTTON_FILL } from "@/types/enum/ionicEnum";
import { FilterBaseEmits } from "@/types/emits";


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterBase',
  emits: ["back", "reset", "apply"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), {
    style: {"height":"calc(100% - 56px)"},
    class: "bg-transparent purple-purple-color overflow-auto p-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), { class: "p-0" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(_unref(IonRow), {
        class: "p-sticky light-light-background",
        style: {"bottom":"0","z-index":"1"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), null, {
            default: _withCtx(() => [
              _createVNode(ButtonBase, {
                fill: _unref(BUTTON_FILL).OUTLINE,
                class: "coral-coral-color max-width",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('button.reset')), 1)
                ]),
                _: 1
              }, 8, ["fill"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), { class: "d-flex ion-justify-content-end" }, {
            default: _withCtx(() => [
              _createVNode(ButtonBase, {
                class: "max-width",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('apply')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('button.apply')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})